import keyEventHandler from "./keyEventHandler";

let __popperHandler = {

    __processButtons: function(options) {

        let defaultButtons = {
            confirm: {
                label: 'Tamam',
                class: 'button--green',
            },
            cancel: {
                label: 'Vazgeç',
                class: 'button--gray',
            },
            ok: {
                label: 'Tamam',
                class: 'button--gray',
            }
        };

        options.confirm = options.confirm || false;
        options.cancel = options.cancel || false;
        options.ok = options.ok || false;        

        options.buttons = {};

        if (!options.confirm && !options.cancel & !options.ok) {
            options.buttons = {
                'ok': defaultButtons.ok
            }
        } else {
            let buttons = ['confirm', 'cancel', 'ok'];
            for (let i = 0; i < buttons.length; i++) {
                let button = buttons[i];

                if (undefined !== options[button] && options[button] !== false) {
                    options.buttons[button] = {
                        label: options[button].label || defaultButtons[button].label,
                        class: options[button].class || defaultButtons[button].class,
                        handler: options[button].handler || false
                    }
                }
            }
        }

        return options.buttons;
    },

    __processInputs: function(options) {
            
        let defaultInputs = [];

        options.inputs = options.inputs || defaultInputs;

        return options.inputs;
    },

    __processOptions: function(options) {

        options = options || {};

        options.title = options.title || false;
        options.body = options.body || false;
        
        options.buttons = this.__processButtons(options);
        options.inputs = this.__processInputs(options);

        return options;
    },

    __dissmissPop: function(popModal) {
        document.body.classList.remove('popper--active');
        if (popModal) {
            popModal.remove();
        }
        return false;
    },

    __bindEventListener: function() {
        let self = this;
        document.body.addEventListener('keydown', function(event) {
            let key = keyEventHandler(event);
            if (key.key == 'Escape') {
                self.__dissmissPop(document.querySelector('.popper'));
            }
        });
    },

    __getInputValues: function() {
        let values = {};

        let inputs = Array.from(document.querySelectorAll('.popper-input'));

        for (let i = 0; i < inputs.length; i++) {
            let input = inputs[i];
            values[input.name] = input.value;
        }
        return values;
    },

    __showPop: function(options) {

        let self = this;
        let dismissHandler = this.__dissmissPop;

        let popperOverlay = document.querySelector('.popper-overlay');
        if (!popperOverlay) {
            popperOverlay = document.createElement('div');
            popperOverlay.className = 'popper-overlay';
            document.body.appendChild(popperOverlay);
            this.__bindEventListener();
        }

        let popModal = document.createElement('div');
        popModal.className = 'popper';
        
        popperOverlay.onclick = function() {
            return dismissHandler(popModal);
        }

        popperOverlay.addEventListener('keydown', function(event) {
            console.log(event);
        });

        let wrapper = document.createElement('div');
        wrapper.className = 'popper-wrapper';
        popModal.appendChild(wrapper);

        let container = document.createElement('div');
        container.className = 'popper-container';
        wrapper.appendChild(container);

        let header = document.createElement('div');
        header.className = 'popper-header';
        container.appendChild(header);

        let title = document.createElement('p');
        title.className = 'popper-title';
        title.innerText = options.title || '';
        header.appendChild(title);

        let dismissButton = document.createElement('button');
        dismissButton.className = 'button button--transparent';
        dismissButton.setAttribute('type', 'button');
        dismissButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>';
        dismissButton.onclick = function() {
            return dismissHandler(popModal);
        }
        header.appendChild(dismissButton);

        let body = document.createElement('div');
        body.className = 'popper-body';
        container.appendChild(body);

        let message = document.createElement('p');
        message.className = 'popper-message';
        message.innerHTML = (options.body || '').replace(/\n/g, '<br>');
        body.appendChild(message);

        let footer = document.createElement('footer');
        footer.className = 'popper-footer';
        container.appendChild(footer);

        for (let i = 0; i < options.inputs.length; i++) {
            let input = options.inputs[i];

            let inputWrapper = document.createElement('div');
            inputWrapper.className = 'popper-input-wrapper';

            let inputLabel = document.createElement('label');
            inputLabel.className = 'popper-input-label';
            inputLabel.innerText = input.label;
            inputWrapper.appendChild(inputLabel);

            let inputElement = document.createElement('input');
            inputElement.className = 'popper-input';
            inputElement.setAttribute('type', 'text');
            inputElement.setAttribute('name', input.name);
            inputElement.setAttribute('placeholder', input.placeholder || "");

            if (input.required) {
                inputElement.setAttribute('required', 'required');
            }

            inputWrapper.appendChild(inputElement);

            body.appendChild(inputWrapper);
        }


        for (let i = 0; i < Object.keys(options.buttons).length; i++) {

            let key = Object.keys(options.buttons)[i];
            let button_options = options.buttons[key];

            let button = document.createElement('button');
            button.className = 'button ' + button_options.class;
            button.innerHTML = `<span>${button_options.label}</span>`;
            button.setAttribute('type', 'button');
            if (button_options.handler) {
                button.onclick = function() {
                    if (button_options.handler(self.__getInputValues())) {
                        dismissHandler(popModal);
                    }
                    return false;
                }
            } else {
                button.onclick = function() {
                    dismissHandler(popModal);
                    return false;
                }
            }
            footer.appendChild(button);
        }

        document.body.appendChild(popModal);
        document.body.classList.add('popper--active');
    },

    confirm: function(options) {
        options = this.__processOptions(options);
        this.__showPop(options);
    }

}

export default __popperHandler;